import { useEffect, useState } from 'react'

import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import type { Deposit, Deposits } from '@awaze/mfe-common.configs.brand'
import { getActiveDepositScheme } from '@awaze/mfe-common.configs.brand'
import type { CommonSite } from '@awaze/mfe-common.types-and-mocks.site-search-service'

interface UseGetActiveDepositSchemeArgs {
  brand: Brand
  country: string
  deposits: Deposits
  propertyInfo: CommonSite | null
}

interface UseGetActiveDepositSchemeReturn {
  activeDeposit: Deposit | null
}

export const useGetActiveDepositScheme = ({
  brand,
  country,
  deposits,
  propertyInfo,
}: UseGetActiveDepositSchemeArgs): UseGetActiveDepositSchemeReturn => {
  const [activeDeposit, setActiveDeposit] = useState<Deposit | null>(null)

  useEffect(() => {
    const dateToday = new Date()
    const isSite = propertyInfo?.cardinality === 'MULTI'
    const cottageType = brand === 'novasol' ? 'novasol_cottages' : 'cottages'
    const accommodationType = isSite ? 'accom' : cottageType
    const sleeps = isSite ? 0 : (propertyInfo?.property?.sleeps ?? 0)
    const bookingPrice = isSite
      ? (propertyInfo.priceFrom ?? 0)
      : (propertyInfo?.price ?? 0)

    const activeDeposit = propertyInfo?.startDate
      ? getActiveDepositScheme(
          deposits,
          dateToday,
          new Date(propertyInfo.startDate),
          sleeps,
          bookingPrice,
          accommodationType,
          country,
        )
      : null

    setActiveDeposit(activeDeposit)
  }, [propertyInfo])

  return { activeDeposit }
}
